<template>
    <div>
        <div
            class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
            @dragover="allowDrop"
            @drop="onDrop"
        >
            <div class="space-y-1 text-center" v-if="!image">
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <div class="flex text-sm text-gray-600">
                    <label
                        for="file-upload"
                        class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                    >
                        <span>Upload a file</span>
                        <input
                            id="file-upload"
                            ref="file"
                            type="file"
                            class="sr-only"
                            multiple
                            :accept="accept"
                            @change="onChange"
                        />
                    </label>
                    <p class="pl-1">or drag and drop</p>
                </div>
                <p class="text-xs text-gray-500">{{format}} up to 2MB</p>
            </div>
        </div>
        <p class="mx-4 my-2 font-medium text-md text-red-500" v-if="error">
            {{ error }}
        </p>
        <exception class="my-2" />
    </div>
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import Exception from "./Exception";

export default {
    components: {
        Exception,
    },
    props: ["resolution", "maxsize"],
    props: {
        resolution: {
            type: String,
            default:'',
        },
        maxsize: {
            type: String,
            default:'',
        },
        link:{
            type: String,
        },
        format:{
            type: String,
            default:'PNG, JPG, JPEG'
        },
        accept:{
            type:String,
            default:null
        }
    },

    emits: ['reload'],
    data() {
        return{
            image: '',
            error:''
        }
    },
    methods: {
        focus() {
            this.$refs.file.focus()
        },
        onDrop: function(e) {
            e.stopPropagation();
            e.preventDefault();
            var files = e.dataTransfer.files;
            let formData = new FormData();
            for( var i = 0; i < files.length; i++ ){
                let file = files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('resolution',this.resolution??'');
            formData.append('maxsize',this.maxsize??'');
            this.uploadFile(formData)
        },
        allowDrop: function(ev) {
            ev.preventDefault();
        },
        onChange(e) {
            var files = e.target.files;
            let formData = new FormData();
            for( var i = 0; i < files.length; i++ ){
                let file = files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('resolution',this.resolution??'')
            formData.append('maxsize',this.maxsize??'')
            this.uploadFile(formData)
        },
        uploadFile(formData) {
            Inertia.post(this.link, formData,{ headers: { 'Content-Type': 'multipart/form-data' } }).then(res => this.$emit('reload') );
        }
    }
};
</script>
<style>
.img {
    width: 300px;
}
</style>
